import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "modal fade show d-block",
    tabindex: "-1",
    role: "dialog",
    "raria-hidden": "true"
};
const _hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const _hoisted_3 = { class: "modal-content" };
const _hoisted_4 = { class: "modal-header" };
const _hoisted_5 = {
    class: "modal-title",
    id: "confirmeModalLongTitle"
};
const _hoisted_6 = { class: "modal-body" };
const _hoisted_7 = ["innerHTML"];
import { ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ValidateModal',
    props: {
        modalTitle: {
            type: String,
        },
        modalContent: {
            type: Array
        }
    },
    emits: ['confirm'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const validateText = ref(props.modalContent);
        const hideModal = () => {
            emit('confirm'); // lo chiude il padre
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("h5", _hoisted_5, _toDisplayString(props.modalTitle), 1)
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _cache[0] || (_cache[0] = _createElementVNode("div", null, "Per salvare l'itinerario deve essere completato l'inserimento dei seguenti campi:", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validateText.value, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    innerHTML: item,
                                    class: "px-3"
                                }, null, 8, _hoisted_7));
                            }), 128))
                        ]),
                        _createElementVNode("div", { class: "modal-footer" }, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-primary",
                                onClick: hideModal
                            }, "Conferma")
                        ])
                    ])
                ])
            ]));
        };
    }
});
